export enum VerticalsEnum {
  NUTRA = "NUTRA",
  GAMBLING = "GAMBLING"
}